<template>
    <button :style="[{'--asc-desc-color': color??'#718EBF'}]" :class="['asc-desc-wrapper','d-flex', 'align-items-center','justify-content-center', 'gap-1', 'w-100', {'asc': activeMode}, {'desc': !activeMode}]">
        <slot name="text-content">

        </slot>
        <svg  v-if="isActive" class="asc-desc-image" xmlns="http://www.w3.org/2000/svg" width="17" height="8" viewBox="0 0 17 8" fill="none">
            <path d="M16 1L8.5 7L1 1" :stroke="color??'#718EBF'" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </button>
</template>
<script>
// svg image is the alternative of the following image
/* <img v-if="isActive" class="asc-desc-image" src="@/assets/images/arrow.svg" alt=""> */

export default {
    data(){
        return {

        }
    },
    props: {
        isActive: {
            type: Boolean,
            default: false,
        },
        activeMode: {
            type: Boolean,
            default: false,
        },
        color: {
            type: String,
            default: '#718EBF', // light-blue
        },
    },
}
</script>
<style scoped>
.asc-desc-wrapper{
    color: var(--asc-desc-color);
}
.asc-desc-image{
    transition: all 0.3s linear;
}
button.asc > .asc-desc-image{
    transform: rotate(180deg);
    justify-content: space-between;
}
/* --asc-desc-color */
</style>